import classNames from 'classnames';
import { IconV1 } from 'common/icon/iconV1.js';
import { ReactNode } from 'react';
import { useMeasure } from 'utilities/hooks/use-measure.js';

interface IAccordionItemProps {
  heading: ReactNode;
  body: ReactNode;
  bodyClassName?: string;
  toggleCallback: (index: number) => void;
  isOpen: boolean;
  index: number;
  warningSeverityClass?: string;
}

export const AccordionItem = ({
  heading,
  body,
  isOpen,
  bodyClassName,
  warningSeverityClass,
  index,
  toggleCallback,
}: IAccordionItemProps) => {
  const [headRef, headBounds] = useMeasure<HTMLDivElement>();
  const [bodyRef, bodyBounds] = useMeasure<HTMLDivElement>();

  const onClickHandler = () => {
    toggleCallback(index);
  };

  const rootMaxHeight =
    headRef.current && bodyRef.current
      ? `${(isOpen ? bodyBounds.height : 0) + headBounds.height}px`
      : `${headBounds.height}px`;

  return (
    <li
      className={classNames('Accordion-item', { 'is-open': isOpen })}
      style={{ minHeight: headBounds.height, maxHeight: rootMaxHeight }}
    >
      <div ref={headRef}>
        <div className={`Accordion-item-head u-flex ${warningSeverityClass ?? ''}`} onClick={onClickHandler}>
          <div className="u-flex-1">{heading}</div>
          <div className="u-flexGrow-0">
            <IconV1 icon={`${isOpen ? 'chevron-up' : 'chevron-down'}`} iconClass="svg--1em" />
          </div>
        </div>
      </div>
      <div className={classNames('Accordion-item', { bodyClassName })} ref={bodyRef}>
        {body}
      </div>
    </li>
  );
};
